import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const Select2Multiple = ({ options, onChange, disabled, defaultValue }) => {
  const [selectedOptions, setSelectedOptions] = useState(defaultValue || []);

  const handleChange = selectedOptions => {
    setSelectedOptions(selectedOptions);
    if (onChange) {
      onChange(selectedOptions);
    }
  };

  useEffect(() => {
    setSelectedOptions(defaultValue || []);
  }, [defaultValue]);

  return (
    <div>
      <Select
        isMulti
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        isDisabled={disabled}
      />
    </div>
  );
};

export default Select2Multiple;
